import React, { useEffect, useRef } from 'react';
import '../../../components/ConfirmModal/styles.css';
import '../styles/DesignNameModal.css';

const DesignNameModal = ({
  isOpen,
  title,
  message,
  value,
  onChange,
  onConfirm,
  onCancel,
  confirmText = 'Create',
  cancelText = 'Cancel',
  errorMessage,
  loading,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (!loading && onCancel) {
      onCancel();
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!loading && onConfirm) {
      onConfirm();
    }
  };

  return (
    <div className="confirm-modal-overlay" onClick={handleOverlayClick}>
      <div
        className="confirm-modal-container"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="confirm-modal-content">
          <div className="confirm-modal-icon">
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M16.862 4.487a2.25 2.25 0 013.182 3.182L8.25 19.463l-4.5 1 1-4.5L16.862 4.487z"
              />
            </svg>
          </div>
          <h2 className="confirm-modal-title">{title}</h2>
          {message && <p className="confirm-modal-message">{message}</p>}
          <form onSubmit={handleSubmit} className="design-name-form">
            <input
              ref={inputRef}
              className="design-name-input"
              value={value}
              onChange={(event) => onChange(event.target.value)}
              disabled={loading}
            />
            {errorMessage && <div className="design-name-error">{errorMessage}</div>}
            <div className="confirm-modal-buttons">
              <button
                type="submit"
                className="confirm-modal-btn confirm-btn"
                disabled={loading}
              >
                {loading ? 'Creating...' : confirmText}
              </button>
              <button
                type="button"
                className="confirm-modal-btn cancel-btn"
                onClick={onCancel}
                disabled={loading}
              >
                {cancelText}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DesignNameModal;
